'use client';

import { toHumanFormat } from '@wolfejs/core/utils/number';
import type { NumberFormatBaseProps } from 'react-number-format';
import { NumberFormatBase } from 'react-number-format';

export type FormatCurrencyProps = {
  className?: string;
  numberFormatBaseProps: NumberFormatBaseProps;
  decimalScale?: number;
  useHumanReadable?: boolean;
  prefix?: string;
};

export function FormatCurrency({
  className,
  numberFormatBaseProps,
  decimalScale = 2,
  useHumanReadable = false,
  prefix,
}: FormatCurrencyProps) {
  const format = (numStr: string) => {
    if (numStr === '') return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: decimalScale,
    }).format(+numStr);
  };

  const humanReadableFormat = (numStr: string) => {
    if (numStr === '') return '';
    return prefix ? `${prefix}${toHumanFormat(Number(numStr))}` : toHumanFormat(Number(numStr));
  };

  return (
    <NumberFormatBase
      className={className}
      {...numberFormatBaseProps}
      format={useHumanReadable ? humanReadableFormat : format}
    />
  );
}
